class BESSAppProjectProfilerItemData {

    constructor(data) {
        this.recordId = data['record'];
        this.name = data['name'];
        this.itemNo = data['item_no'];
        this.canDelete = data['can_delete'];
        this.isNew = this.recordId === null;
        this.values = _.map(data['fields'], (x) => new BESSAppProjectProfilerItemValueData(x));
        this.dependencies = _.map(data['dependencies'], (x) => new BESSAppProjectProfilerDependencyData(x));
        this.valueFor = {};
    }

    getEventIdentifier() {
        if(this.isNew) {
            return 'NEW_' + this.itemNo;
        }
        return this.recordId;
    }


    createCopy() {
        let data = this.toData();
        data['record'] = null;
        let item = new BESSAppProjectProfilerItemData(data);
        item.values[0].value = 'Copy of ' + this.values[0].value;
        return item;
    }

    static createNew(fields, what, itemNo) {
        return new BESSAppProjectProfilerItemData({
            record: null,
            can_delete: true,
            name: what,
            item_no: itemNo,
            fields: _.map(fields, function (field) {
                return {
                    applicable: true,
                    value: field.defaultValue,
                };
            })
        });
    }

    toData() {
        return {
            'record': this.recordId,
            'fields': _.map(this.values, (x) => x.toData())
        };
    }
}